export const environment = {
    production: true,
    SyncFusion: {
        LicenseKey: 'Ngo9BigBOggjHTQxAR8/V1JFaF5cXGRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWH1edHRUR2JZV0d3XkNWYEA='
    }
};
